export default __webpack_public_path__ + "static/media/logo_nice.3f23f8ea.png";